import { Rich } from '@/components/Rich'
import type { Challenge } from '@/domain/workout'
import type { Progress } from '@/domain/session'
import { crewBonusUsed, totalCredits } from '@/domain/session'
import { cx } from '@/lib/cx'
import styles from './panel.module.css'

/** Cabecera común de sección: título a la izquierda, apunte a la derecha. */
export function SectionHead({ title, note }: { title: string; note?: string }) {
  return (
    <h2 className={styles.sectionHead}>
      <b>{title}</b>
      {note && <span className="mono">{note}</span>}
    </h2>
  )
}

export function Rules({ challenge }: { challenge: Challenge }) {
  return (
    <section className={styles.section}>
      <SectionHead title="Para que cuente" note={`${String(challenge.rules.length).padStart(2, '0')} reglas`} />
      {challenge.rules.map((rule, index) => (
        <div key={rule.title} className={styles.rule}>
          <span className={styles.ruleIndex}>{String(index + 1).padStart(2, '0')}</span>
          <div>
            <b>{rule.title}</b>
            <p>{rule.description}</p>
          </div>
        </div>
      ))}
    </section>
  )
}

export function Bonus({ challenge, progress }: { challenge: Challenge; progress: Progress }) {
  const bonus = challenge.bonus
  if (!bonus) return null

  const used = crewBonusUsed(progress)

  return (
    <section className={styles.section}>
      <SectionHead title="Crew Bonus" note="×2" />
      <div className={styles.bonus}>
        <h3>
          {bonus.title.map((line, index) => (
            <span key={index}>
              {line}
              {index < bonus.title.length - 1 && <br />}
            </span>
          ))}
        </h3>
        {bonus.paragraphs.map((paragraph, index) => (
          <p key={index}>
            <Rich parts={paragraph} />
          </p>
        ))}
        {used > 0 && (
          <p className={styles.bonusUsed}>
            Usado {used} de {bonus.maxUses}
          </p>
        )}
      </div>
    </section>
  )
}

export function Prizes({ challenge, progress }: { challenge: Challenge; progress: Progress }) {
  const credits = totalCredits(progress)

  return (
    <section className={styles.section}>
      <SectionHead title="Lo que te llevas" note="Septiembre" />
      {[...challenge.prizes]
        .sort((a, b) => b.sessions - a.sessions)
        .map((prize, index) => (
          // El premio mayor siempre destacado: es el objetivo del reto.
          // Los demás se encienden al alcanzarlos.
          <div
            key={prize.sessions}
            className={cx(styles.prize, index > 0 && credits < prize.sessions && styles.prizeDim)}
          >
            <span className={styles.prizeCount}>
              <b>{prize.sessions}</b>
              <span>Sesiones</span>
            </span>
            <div>
              <strong>{prize.title}</strong>
              <span className={styles.prizeDesc}>{prize.description}</span>
            </div>
          </div>
        ))}
    </section>
  )
}
